import './filters'
import './lib/axios.js'
import './lib/gmap.js'
import './lib/global-mixin.js'

import { Vue } from '~/addiesaas'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)

import components from './components'
import layouts from './layouts'
import directives from './directives'

export default {
    components,
    layouts,
    directives,
}
